import { render, staticRenderFns } from "./ChatErrorMsg.vue?vue&type=template&id=d0920b22"
import script from "./ChatErrorMsg.vue?vue&type=script&lang=js"
export * from "./ChatErrorMsg.vue?vue&type=script&lang=js"
import style0 from "./ChatErrorMsg.vue?vue&type=style&index=0&id=d0920b22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports